import styles from './Authentication.module.css';

const layoutStyles = {
    container: `p-5 min-h-screen h-screen flex overflow-hidden flex-row ${styles.container} 
    `,
    slider_wrpr: `h-full w-1/2 block ${styles.slider_wrpr}
    `,
    page_section_wrpr: `w-1/2 pr-5 flex flex-col gap-5 h-full overflow-hidden overflow-y-auto ${styles.page_section_wrpr}
    `
}

export { layoutStyles }
